import { useState, useEffect } from "react";

// True on touch-first / small-screen devices. Used to switch the sequence
// builder into a tap-based interaction model while desktop keeps drag-and-drop.
export function useIsTouch() {
  const [touch, setTouch] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia("(pointer: coarse)");
    const update = () => {
      const hasTouch = navigator.maxTouchPoints > 0 || "ontouchstart" in window;
      setTouch(mq.matches || hasTouch || window.innerWidth < 768);
    };
    update();
    mq.addEventListener?.("change", update);
    window.addEventListener("resize", update);
    return () => {
      mq.removeEventListener?.("change", update);
      window.removeEventListener("resize", update);
    };
  }, []);
  return touch;
}
